import {
    doGetQCXRequest,
    doPostQCXRequest,
    doPutQCXActivateRequest,
    doPutQCXInactivateRequest,
    doPutQCXRequest,
  } from '../../utils/api/domain/domain-api-utils';
import { TABELA_FRENTE_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

async function fetchAll() {
    return doGetQCXRequest([TABELA_FRENTE_ENDPOINT]);
}
async function fetchById(id) {
    return doGetQCXRequest([
        TABELA_FRENTE_ENDPOINT,
        id,
    ]);
}
async function register(data, queryParams = []) {
    return doPostQCXRequest(
        [TABELA_FRENTE_ENDPOINT],
        data,
        queryParams
    );
}
async function save(data, queryParams = []) {
    return doPutQCXRequest(
        [TABELA_FRENTE_ENDPOINT],
        data,
        queryParams
    );
}
async function activateById(id) {
    return doPutQCXActivateRequest(
        [TABELA_FRENTE_ENDPOINT],
        id
    );
}
async function inactivateById(id) {
    return doPutQCXInactivateRequest(
        [TABELA_FRENTE_ENDPOINT],
        id
    );
}

async function fetchAllByCliente(clienteId) {
  return doGetQCXRequest([TABELA_FRENTE_ENDPOINT, 'by-cliente', clienteId]);
}


const tabelaFreteAPI = {
    fetchAll,
    fetchById,
    register,
    save,
    activateById,
    inactivateById,
    fetchAllByCliente,
};

export {
    tabelaFreteAPI,
    fetchAll,
    fetchById,
    register,
    save,
    activateById,
    inactivateById,
    fetchAllByCliente,
  };
  